import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestAddSqa, ResponseAddSqa } from '@com-delta-idp/mnx-login-ui';
import {
  ApiBuilder,
  AppConfigService,
  EXCEPTION_CATEGORY_ENUM,
  EXCEPTION_FILE_NAMES_ENUM,
  ExceptionTrackingService,
  HttpRequestMethods,
  IExceptionMetadata
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { IDP_APP } from '../../constants/login-constant';
import { LoginModalEndpointsKeys } from '../../models/login-modal.enum';

@Injectable({
  providedIn: 'root'
})
export class AddSqaApiService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private exceptionTrackingService: ExceptionTrackingService
  ) {}

  loginBff = (payload: RequestAddSqa): Observable<ResponseAddSqa> =>
    new ApiBuilder<RequestAddSqa, ResponseAddSqa>(this.http, this.appConfig)
      .app(IDP_APP)
      .endpointKey(LoginModalEndpointsKeys['SAVE_ADD_SECURITY_QUESTIONS'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .errorHandler(this.handleError.bind(this))
      .create();

  handleError(error: HttpErrorResponse): Observable<never> {
    const exceptionMetadata: IExceptionMetadata = {
      fileName: EXCEPTION_FILE_NAMES_ENUM.ADD_SQA_API_SERVICE,
      methodName: 'handleError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: error.error
    };
    this.exceptionTrackingService?.track(
      `[${IDP_APP}]: ${error.status} : ${error.url}`,
      exceptionMetadata
    );
    return throwError(error);
  }
}
